<template>
  <div>
    <top-header v-bind:title="$t('categories')">
      <header-button icon="mdi-plus-box"
                     right
                     slot="right-button"
                     v-bind:label="$t('add')"
                     v-bind:to="{ name: 'learning-category-add' }" />
    </top-header>
    <v-container>
      <category-table-card item-route-name="learning-category"
                          v-bind:loading="loading"
                          v-bind:categories="categories" />
    </v-container>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  import HeaderButton from '@/components/common/HeaderButton.vue'
  import TopHeader from '@/components/common/TopHeader.vue'
  import CategoryTableCard from '@/components/learning/CategoryTableCard.vue'

  export default {
    components: {
      HeaderButton,
      CategoryTableCard,
      TopHeader
    },
    computed: {
      ...mapGetters({
        categories: 'learning/categories'
      })
    },
    async created() {
      this.loading = true

      await this.loadCategories()

      this.loading = false
    },
    data: () => ({
      loading: false
    }),
    methods: {
      ...mapActions({
        loadCategories: 'learning/loadCategories'
      })
    },
    name: 'Categories'
  }
</script>

<i18n>
  {
    "de": {
      "add": "Neu",
      "categories": "Kategorien"
    },
    "en": {
      "add": "Add",
      "categories": "Categories"
    }
  }
</i18n>